/**
 * Cookie工具函数
 */

/**
 * 获取指定名称的cookie值
 * @param {string} name - cookie名称
 * @returns {string|null} - cookie值，如果不存在返回null
 */
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

/**
 * 设置cookie
 * @param {string} name - cookie名称
 * @param {string} value - cookie值
 * @param {number} days - 过期天数，默认7天
 * @param {string} path - 路径，默认'/'
 */
export function setCookie(name, value, days = 7, path = '/') {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=${path}`;
}

/**
 * 删除指定名称的cookie
 * @param {string} name - cookie名称
 * @param {string} path - 路径，默认'/'
 */
export function deleteCookie(name, path = '/') {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path}`;
}

/**
 * 获取be-site#lang的cookie值
 * @returns {string|null} - 语言代码，如果不存在返回null
 */
export function getJaecooSiteLang() {
  return getCookie('be-site#lang');
}

/**
 * 设置be-site#lang的cookie值
 * @param {string} lang - 语言代码 (如: 'en', 'nl')
 * @param {number} days - 过期天数，默认30天
 */
export function setJaecooSiteLang(lang, days = 30) {
  setCookie('be-site#lang', lang, days);
}

/**
 * 获取所有cookie并转换为对象
 * @returns {Object} - cookie对象
 */
export function getAllCookies() {
  const cookies = {};
  document.cookie.split(';').forEach((cookie) => {
    const [name, value] = cookie.trim().split('=');
    if (name && value) {
      cookies[name] = decodeURIComponent(value);
    }
  });
  return cookies;
}
